const currencies = [
  { abbr: "USD", sign: "$", currency: "US Dollar (United States)" },
  { abbr: "CAD", sign: "CA$", currency: "Canadian Dollar (Canada)" },

  { abbr: "GBP", sign: "£", currency: "British Pound (United Kingdom)" },
  { abbr: "EUR", sign: "€", currency: "Euro (European Union)" },
  { abbr: "CHF", sign: "CHF", currency: "Swiss Franc (Switzerland)" },

  { abbr: "CNY", sign: "¥", currency: "Chinese Yuan (China)" },
  { abbr: "JPY", sign: "¥", currency: "Japanese Yen (Japan)" },
  { abbr: "KRW", sign: "₩", currency: "South Korean Won (South Korea)" },
  { abbr: "INR", sign: "₹", currency: "Indian Rupee (India)" },
  { abbr: "AUD", sign: "A$", currency: "Australian Dollar (Australia)" },
  { abbr: "SGD", sign: "S$", currency: "Singapore Dollar (Singapore)" },
  { abbr: "TWD", sign: "NT$", currency: "New Taiwan Dollar (Taiwan)" },

  { abbr: "AED", sign: "د.إ", currency: "UAE Dirham (United Arab Emirates)" },
  { abbr: "SAR", sign: "﷼", currency: "Saudi Riyal (Saudi Arabia)" },

  { abbr: "NZD", sign: "NZ$", currency: "New Zealand Dollar (New Zealand)" },
];
export default currencies;
